<template>
    <div>
        <div class="games py-5 mx-auto" >
            <carousel
                :per-page="1"
                :pagination-enabled="false"
                :key="resetCarouselId"
                ref="carousel">
                <slide v-for="(slide, slideIndex) in filteredGames" :key="slideIndex">
                    <div class="games-container flex items-center justify-space-evenly flex-wrap mx-auto"
                        :class="'cols-' + columns" :style="{'height': containerHeight + 'px'}">
                        <div
                            v-for="(game, index) in slide"
                            class="block game">
                            <a
                                class="block"
                                :class="{'selected' : isGameSelected(slideIndex, index)}"
                                @click="openGame(game.id)">
                                <div class="game-img">
                                    <img :alt="game.name" :src="game.imageUrl"
                                         :style="{'max-width': maxGameWidth + 'px', 'max-height': maxGameHeight - 32 + 'px'}">
                                    <div class="game-play">
                                        <font-awesome-icon :icon="['far', 'play-circle']" class="play-icon"/>
                                    </div>
                                </div>
                                <div class="px-4 py-2 game-name">
                                    <div class="flex space-between text-lg">
                                        {{ game.name }}
                                    </div>
                                </div>
                            </a>
                        </div>
                        <template v-if="slide.length < gamesInView">
                            <div
                                v-for="n in (gamesInView - slide.length)"
                                class="block game"
                                :style="{'width': maxGameWidth + 10 + 'px', 'height': maxGameHeight + 'px'}"
                            />
                        </template>
                    </div>
                </slide>
            </carousel>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import GameMixin from "../../Shared/mixin/Game";
export default {
    name: 'Games',
    mixins: [
        GameMixin,
    ],
    props: {
        games: Array,
        lobbyRows: Number,
        lobbyColumns: Number,
        gameVolume: Number,
        maxHeight: {
            type: Number|null,
            default: null,
            required: false
        },
    },
    data() {
        return {
            selectedGame: {
                slideIndex: 0,
                gameIndex: 0,
            },
            rows: this.lobbyRows,
            columns: this.lobbyColumns,
            gamesInView: this.lobbyRows * this.lobbyColumns,
            slideCount: 1,
            currentPage: 0,
            filteredGames: _.chunk(this.games, this.gamesInView),
            resetCarouselId: 0,
            containerHeight: 0,
            maxGameWidth: 0,
            maxGameHeight: 0,
        }
    },
    created() {
        window.addEventListener('keydown', this.listenOnKey);
        window.addEventListener("resize", this.maxGameSize);
        this.slideCount = Math.ceil(this.games.length / this.gamesInView);
        this.currentPage = 0;
        this.filteredGames = _.chunk(this.games, this.gamesInView);
        this.$nextTick(() => {
            this.resetCarouselId ++;
        });
        this.maxGameSize();

        Echo
            .private(`player-${this.$page.props.user.id}`)
            .listen('LobbyGridChanged', (event) => {
                this.rows = event.rows;
                this.columns = event.columns;
                this.gamesInView = this.rows * this.columns;
                this.selectedGame.gameIndex = 0;
                this.selectedGame.slideIndex = 0;
                this.slideCount = Math.ceil(this.games.length / this.gamesInView);
                this.filteredGames = _.chunk(this.games, this.gamesInView);
                this.resetCarouselId ++;
                this.maxGameSize();
            });
    },
    methods: {
        getPlayUrl(gameId) {
            return `/play/${gameId}?volume=` + encodeURIComponent(this.gameVolume / 100);
        },
        isGameSelected(slideIndex, gameIndex) {
            return slideIndex === this.selectedGame.slideIndex && gameIndex === this.selectedGame.gameIndex;
        },
        listenOnKey(e) {
            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    if(this.selectedGame.gameIndex + this.columns <= this.filteredGames[this.selectedGame.slideIndex].length - 1) {
                        this.selectedGame.gameIndex = this.selectedGame.gameIndex + this.columns;
                    }
                    this.$refs.carousel.goToPage(this.selectedGame.slideIndex);
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    if(this.selectedGame.gameIndex - this.columns >= 0) {
                        this.selectedGame.gameIndex = this.selectedGame.gameIndex - this.columns;
                    }
                    this.$refs.carousel.goToPage(this.selectedGame.slideIndex);
                    break;
                case 'ArrowLeft':
                    e.preventDefault();
                    const isFirstOnSlide = this.selectedGame.gameIndex % this.columns === 0;
                    const isFirstSlide = this.selectedGame.slideIndex === 0;

                    if(!isFirstOnSlide) {
                        this.selectedGame.gameIndex--;
                    }
                    if(isFirstOnSlide && !isFirstSlide) {
                        this.selectedGame.slideIndex--;
                        this.selectedGame.gameIndex = this.selectedGame.gameIndex  + this.columns - 1;
                    }
                    this.$refs.carousel.goToPage(this.selectedGame.slideIndex);
                    break;
                case 'ArrowRight':
                    e.preventDefault();
                    const isLastOnSlide = (this.selectedGame.gameIndex + 1) % this.columns === 0;
                    const isLastSlide = this.selectedGame.slideIndex >= this.slideCount - 1;

                    if(isLastSlide && this.selectedGame.gameIndex >= this.filteredGames[this.selectedGame.slideIndex].length - 1) {
                        return;
                    }

                    if(!isLastOnSlide) {
                        this.selectedGame.gameIndex++;
                    }

                    if(isLastOnSlide && !isLastSlide) {
                        this.selectedGame.slideIndex++;
                        if((this.selectedGame.gameIndex  - this.columns + 1) > this.filteredGames[this.selectedGame.slideIndex].length) {
                            this.selectedGame.gameIndex = 0;
                        } else {
                            this.selectedGame.gameIndex = this.selectedGame.gameIndex  - this.columns + 1;
                        }
                    }
                    this.$refs.carousel.goToPage(this.selectedGame.slideIndex);
                    break;
                case 'Enter':
                    e.preventDefault();
                    this.openGame();
                    break;
                case ' ':
                    e.preventDefault();
                    this.openGame();
                    break;
            }
        },
        openGame(gameId = this.games[(this.selectedGame.slideIndex * this.rows *this.columns) + this.selectedGame.gameIndex].id) {
            this.openTerminalGame(gameId);
        },
        maxGameSize() {
            this.$nextTick(() => {
                const maxGameHeight = this.maxHeight !== null ? this.maxHeight - 10 : window.innerHeight - 114;
                const containerHeight = this.maxHeight !== null ? this.maxHeight : window.innerHeight - 104;
                this.maxGameWidth = (window.innerWidth - 32) / this.columns - (this.columns * 10);
                this.maxGameHeight = maxGameHeight / this.rows - (this.rows * 10);
                this.containerHeight = containerHeight;
            });
        }
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.listenOnKey);
        window.removeEventListener('resize', this.maxGameSize);
    }
}
</script>

<style lang="scss" scoped>
.carousel {
    position: relative;
}

.games {
    width: 100%;

    .games-container {
        height: 100%;
        display: grid;
        grid-template-columns: auto auto;
        column-gap: 5px;
        row-gap: 5px;
    }

    .cols-2 {
        grid-template-columns: auto auto;
    }

    .cols-3 {
        grid-template-columns: auto auto auto;
    }

    .cols-4 {
        grid-template-columns: auto auto auto auto;
    }

    .cols-5 {
        grid-template-columns: auto auto auto auto auto;
    }

    .cols-6 {
        grid-template-columns: auto auto auto auto auto auto;
    }

    .game {
        justify-self: center;
        align-self: center;
        padding: 5px;
    }

    .justify-space-evenly {
        justify-content: space-evenly;
    }
}
.game > a {
    border-radius: 5px;
    transition: .4s box-shadow ease-in;
    cursor: pointer;

    .game-img {
        position: relative;
        border-radius: 5px 5px 0 0;

        img {
            height: auto;
            border-radius: 5px 5px 0 0;
            object-fit: cover;
        }

    }

    .game-name {
        font-weight: 500;
        color: #252f3f;
        background-color: rgba(238,238,238, 0.75);
        border-radius: 0 0 5px 5px;
        transition: .5s all ease-in;
    }

    .game-play {
        font-size: 4rem;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        color: #ddd;
        background-color: rgba(25, 25, 25, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        transition: opacity  .5s ease-in;
        opacity: 0;
    }

    &.selected {
        box-shadow: 0 0 0 5px rgba(238,238,238, 0.75);

        .game-name {
            color: #ddd;
            background-color: var(--terminal-red);
        }

        .game-play {
            opacity: 1;

            .play-icon {
                animation: bounce 1s;
                animation-timing-function: ease-in-out;
            }
        }
    }
}

@keyframes bounce {
    25%{transform: scale(1.2);}
    50%{transform: scale(0.9);}
    75%{transform: scale(1.1);}
    100%{transform: scale(1.0);}
}
</style>
